import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { IoSearch } from "react-icons/io5";
const CostingReport = () => {

    const getCurrentDateUTC = () => {
        const date = new Date();
        return date.toISOString().split("T")[0];
    };
    const getNextMonthDateUTC = (dateString) => {
        const date = new Date(dateString);
        date.setMonth(date.getMonth() + 1);
        return date.toISOString().split("T")[0];
    };
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    const [dateFilter, setdateFilter] = useState(false);
    const [Location, setLocation] = useState([]);
    const apiService = new ApiService();
    const [Item, setItem] = useState(false);
    const [issue, setIssue] = useState(false);
    const [fromDate, setFromDate] = useState(getCurrentDateUTC());
    const [toDate, setToDate] = useState(getNextMonthDateUTC(getCurrentDateUTC()));

    const [formData, setFormData] = useState({
        Category: [{ label: 'Select Item Category', value: 'Select Item Category' }],
        SubCategory: [{ label: 'Select Sub Category', value: 'Select Sub Category' }],
        Locationfrom: [{ label: 'Select From Location', value: 'Select From Location' }],
        Warehouse: [{ label: 'Select To Locatiom', value: 'Select to Location' }],
        LocationCategory: [{ label: 'Select Category', value: 'Select Category' }],
    });
    useEffect(() => {
        setToDate(getNextMonthDateUTC(fromDate));
    }, [fromDate]);

    useEffect(() => {
        // getItems()
        getCat()
    }, []);

    useEffect(() => {
        const today = new Date().toISOString().split("T")[0];
        setFromDate(today);
        setToDate(today);
    }, []);
    const getCat = async () => {
        let Catparam = `?Active=1`;
        let param = `?isActive=true`
        const categoryResponse = await apiService.getApiParamater("GET_CATEGORY", Catparam);
        setCategoryOptions(categoryResponse?.data?.result);
        const subCategoryResponse = await apiService.getApiParamater("GET_SUB_CATEGORY", Catparam);
        setSubCategoryOptions(subCategoryResponse?.data?.result);
        let res = await apiService.get('GET_WAREHOUSE_MASTER')
        setLocation(res?.data?.result)
    }
    const getItems = async () => {
        try {
            const apiService = new ApiService();
            const currentDatetimeUTC = new Date().toISOString();
            const params = new URLSearchParams();
            params.append('Category', formData.Category?.value?.catCode || "0");
            params.append('SubCategory', formData.SubCategory?.value?.subcatcode || "0");
            params.append('Warehouse', formData.Warehouse?.label || "0");
            params.append('AsOnDate', currentDatetimeUTC);
            const res = await apiService.getApiParamater('GET_ITEMS_REPORT', `?${params.toString()}`);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const handleCategoryChange = (selectedOption) => {
        setFormData({ ...formData, Category: selectedOption });
    }
    const handleSubCategoryChange = (selectedOption) => {
        setFormData({ ...formData, SubCategory: selectedOption });
    }
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    };
    const handlefromChange = (selectedOption) => {
        setFormData({ ...formData, Locationfrom: selectedOption });
    }
    const handlelocChange = (selectedOption) => {
        setFormData({ ...formData, Warehouse: selectedOption });
    }
    const handleLocationCategory = (selectedOption) => {
        setFormData({ ...formData, LocationCategory: selectedOption });
    }
    const handleClearFilters = () => {
        setFromDate()
        setToDate()
        setIssue(false)
        setItem(false)
        setdateFilter(false)
        setFormData({
            Category: [{ label: 'Select Category', value: 'Select Category' }],
            SubCategory: [{ label: 'Select Sub Category', value: 'Select Sub Category' }],
            Locationfrom: [{ label: 'Select From Location', value: 'Select Fro Location' }],
            Warehouse: [{ label: 'Select Ware House', value: 'Select Sub Category' }],
        });
    }
    const handleFromDate = (e) => {
        setFromDate(e.target.value);
    };
    const handleToDate = (e) => {
        setToDate(e.target.value);
    };
    const handleItemSelection = (e) => {
        setItem(e);
    };
    const handleIssueSelection = (e) => {
        setIssue(e);
    };
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-8'>
                    <div className='row pb-2'>
                        <div className='col' >
                            <input
                                type='date'
                                className="form-Input w-100"
                                value={fromDate}
                                name="fromDate"
                                disabled={!dateFilter}
                                onChange={handleFromDate}
                                placeholder='From  Date '
                            />
                        </div>
                        <div className='col'>
                            <input
                                type='date'
                                disabled={!dateFilter}
                                className="form-Input w-100"
                                placeholder='To  Date '
                                value={toDate}
                                name="toDate"
                                onChange={handleToDate}
                            />
                        </div>
                        <div className='col gap-2 center'>
                            <input className="form-check-input"
                                type="checkbox"
                                id="dateFilter" style={{ width: "20px", height: "20px" }}
                                name="dateFilter"
                                checked={dateFilter}
                                onChange={(e) => handleDateFilterSelection(e.target.checked)} />
                            <label className=''>Date Filter</label>
                        </div>
                    </div>
                    <div className='row pb-2' >
                        <div className='col-4'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.LocationCategory}
                                onChange={(selectedOption) => handleLocationCategory(selectedOption)}
                                options={categoryOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.catName }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Locationfrom}
                                onChange={(selectedOption) => handlefromChange(selectedOption)}
                                options={Location?.map((loca) => ({ value: loca, label: loca?.description }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.Warehouse}
                                onChange={(selectedOption) => handlelocChange(selectedOption)}
                                options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                            />
                        </div>
                    </div>
                    <div className='row'  >
                        <div className='col-4'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.Category}
                                onChange={(selectedOption) => handleCategoryChange(selectedOption)}
                                options={categoryOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.catName }))}
                            />
                        </div>
                        <div className='col-4'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.SubCategory}
                                onChange={(selectedOption) => handleSubCategoryChange(selectedOption)}
                                options={subCategoryOptions?.map((SubCatOpt) => ({ value: SubCatOpt, label: SubCatOpt?.subcatname }))}
                            />
                        </div>
                        <div className='col-4 gap-3 d-flex'>
                            <label className='pt-2'>Report Group By</label>
                            <div className='gap-2 center'>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Item" style={{ width: "20px", height: "20px" }}
                                    name="Item"
                                    checked={Item}
                                    onChange={(e) => handleItemSelection(e.target.checked)} />
                                <label className=''>Item </label>
                            </div>
                            <div className='gap-2 center'>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="issue" style={{ width: "20px", height: "20px" }}
                                    name="issue"
                                    checked={issue}
                                    onChange={(e) => handleIssueSelection(e.target.checked)} />
                                <label className=''>Issue</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col'></div>
                <div className='col-3 '>
                    <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                        <IoSearch color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CostingReport;